// extracted by mini-css-extract-plugin
export var printerCard = "_ad-1";
export var printerCardConfigured = "_ad-2";
export var printerCardError = "_ad-3";
export var printerCardsContainer = "_ad-0";
export var printerIcon = "_ad-8";
export var printerIconConfigured = "_ad-5";
export var printerIconContainer = "_ad-4";
export var printerIconError = "_ad-6";
export var printerIconUnconfigured = "_ad-7";
export var workstationsTableCard = "_ad-9";